import { motion } from "framer-motion";
import { STEPS } from "../data";

export const HowItWorks = () => {
  return (
    <section id="how" data-testid="how-it-works" className="relative px-5 py-24 md:px-10 md:py-32">
      <div className="mx-auto max-w-[1400px]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-14 md:mb-16"
        >
          <span className="font-accent text-xs uppercase tracking-[0.4em] text-[#ffb000]">Dead Simple</span>
          <h2 className="mt-4 font-display text-4xl font-700 uppercase leading-none chrome-text md:text-6xl">
            How It Works
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.14, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`step-card-${s.n}`}
              className="group relative rounded-3xl border border-white/10 bg-[#080808] p-8 transition-colors duration-500 hover:border-[#ffb000]/50 md:p-10"
            >
              <span className="font-display text-6xl outline-text transition-colors duration-500 group-hover:text-[#ffb000]/20 md:text-7xl">{s.n}</span>
              <h3 className="mt-6 font-accent text-xl font-600 uppercase tracking-wide text-white md:text-2xl">{s.title}</h3>
              <p className="mt-3 font-body text-sm leading-relaxed text-neutral-400">{s.copy}</p>
              <div className="pointer-events-none absolute inset-0 rounded-3xl opacity-0 shadow-[inset_0_0_50px_rgba(255,176,0,0.1)] transition-opacity duration-500 group-hover:opacity-100" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
